<div class="modal-header">
  <h4 class="modal-title">{{modalTitle}}</h4>
  <button type="button"
          class="btn-close"
          aria-hidden="true"
          (click)="closeModal()">
  </button>
</div>

<div class="modal-body">
  <nbc-alert></nbc-alert>

  <br />
  <form #frmPositionRequest="ngForm">
    <nbc-modal-alert></nbc-modal-alert>
    <div class="row">
      <div class="col-md-12">
        <div class="form-box">
          <div class="row">
            <div class="col-md-6">
              <b>Hiring Manager</b>
              <input type="text"
                     name="hiringManager"
                     value="{{hrOnboardingItem.hiringManager}}"
                     class="form-control req-modal"
                     placeholder=""
                     maxlength="100"
                     [disabled]="true" />
            </div>

            <div class="col-md-6">
              <b>Proxy</b>
              <div class="form-group">
                <nbc-select *ngIf="proxyList" name="bu"
                            [source]="proxyList"
                            [(model)]="selectedProxyName"
                            display="description"
                            value="id"
                            placeHolderDisplay="--Select--"
                            placeHolderValue="null"
                            (change)="proxySelected(selectedProxyName)">
                </nbc-select>
              </div>
              <div>
                <span style="color:red" *ngIf="proxyEmail"> {{proxyEmail}} </span>
              </div>
            </div>

          </div>
        </div>
      </div>
      <div class="col-md-12">
        <div class="form-box">
          <div class="row">
            <div class="col-md-6">
              <b>Employee Type</b>
              <input type="text"
                     name="hiringManager"
                     value="{{hrOnboardingItem.employeeType}}"
                     class="form-control req-modal"
                     placeholder=""
                     maxlength="100"
                     [disabled]="true" />
            </div>
          </div>
        </div>
      </div>

      <div class="col-md-12">
        <div class="row"
             style="margin-left:1px">
          <div class="col-md-6">
            <b>Position Start Date</b>  
            <div class="form-group"
                 [ngClass]="{'has-error': !positionStartDate  && isRequiredValidation }">
              <div class="form-group">
                <div class="input-group input-group-set"
                     date-time-append>
                  <span class="input-group-text"><i class="fa fa-calendar"></i></span>

                  <input type="text"
                         name="positionStartDate"
                         class="form-control activity-date-focus req-modal"
                         ngModel
                         required
                         bsDatepicker
                         [(bsValue)]="positionStartDate"
                         #drp="bsDatepicker"
                         placeholder="Position Start Date"
                         [(ngModel)]="positionStartDate"
                         [bsConfig]="{ isAnimated: true, dateInputFormat: 'MM/DD/YYYY', customTodayClass:'custom-today-class'}" />

                </div>
                <span class="control-label control-label-error"
                      *ngIf="!positionStartDate  && isRequiredValidation ">
                  Position Start Date is required.
                </span>
              </div>
            </div>

          </div>
          <div class="col-md-6">
            <b>Company Code</b>
            <div class="form-group">
              <div [ngClass]="{'has-error': !selectedCompanyCode?.id && submitted && isRequiredValidation}">
                <nbc-select *ngIf="companyCodes"
                            name="companyCodeDDl"
                            [source]="companyCodes"
                            [(model)]="selectedCompanyCode"
                            [nbcRequired]="true"
                            [customErrorClass]="(!selectedCompanyCode?.id && submitted) ? 'nbc-control-error':''"
                            display="description"
                            value="id"
                            placeHolderDisplay="Select a Company Code"
                            placeHolderValue="null">
                </nbc-select>
                <span class="control-label control-label-error"
                      *ngIf="!selectedCompanyCode?.id && isRequiredValidation && submitted">
                  Company Code is required.
                </span>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="col-md-12">
        <div class="form-box">
          <h3>Employee Details</h3>
          <div class="row">
            <div class="col-md-12">
              <div class="row">
                <div class="col-md-12">
                  <b>Email</b>
                  <div class="form-group">
                    <input type="text"
                           name="email"
                           value="{{hrOnboardingItem.emailId}}"
                           class="form-control req-modal"
                           placeholder=""
                           maxlength="100"
                           [disabled]="true" />
                  </div>
                </div>
              </div>
            </div>
            <div class="col-md-12">
              <div class="row">
                <div class="col-md-4">
                  <b>First Name</b>
                  <div class="form-group">
                    <input type="text"
                           name="firstName"
                           value="{{hrOnboardingItem.firstName}}"
                           class="form-control req-modal"
                           placeholder=""
                           maxlength="100"
                           [disabled]="true" />
                  </div>
                </div>
                <div class="col-md-4">
                  <b>Middle Name</b>
                  <div class="form-group">
                    <input type="text"
                           name="contactMiddleName"
                           value="{{hrOnboardingItem.middleName}}"
                           class="form-control req-modal"
                           placeholder=""
                           maxlength="100"
                           [disabled]="true" />
                  </div>
                </div>
                <div class="col-md-4">
                  <b>Last Name</b>
                  <div class="form-group">
                    <input type="text"
                           name="lastName"
                           value="{{hrOnboardingItem.lastName}}"
                           class="form-control req-modal"
                           placeholder=""
                           maxlength="100"
                           [disabled]="true" />
                  </div>
                </div>
              </div>
            </div>
            <div class="col-md-12">
              <div class="row">
                <div class="col-md-4">
                  <b>State of Legal Residence</b>

                  <div class="form-group">
                    <input type="text"
                           name="lastName"
                           value="{{hrOnboardingItem.residenceState}}"
                           class="form-control req-modal"
                           placeholder=""
                           maxlength="100"
                           [disabled]="true" />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </form>
</div>

<div class="modal-footer text-right col-md-12">
  <div class="col-md-6">
    <button type="submit"
            class="btn btn-primary"
            [disabled]="!disableSubmitPositionRequestButtonOnClick ? false : true"
            (click)="isRequiredValidation = true;submitted=true;savePositionRequest(frmPositionRequest);">
      Update Request
    </button>
    <button type="button"
            class="btn btn-default"
            (click)="cancel()">
      Close
    </button>
  </div>
</div>
